import script from "./create-user.vue?vue&type=script&setup=true&lang=js"
export * from "./create-user.vue?vue&type=script&setup=true&lang=js"

import "./create-user.vue?vue&type=style&index=0&id=3988ab6f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3988ab6f"]])

export default __exports__